/**
 * Product Pack Offers
 *
 * Two jobs: copy a coupon code to the clipboard, and keep the per-item
 * figures correct when the customer switches variant.
 */
(function () {
  'use strict';

  if (window.__packOffersInit) return;
  window.__packOffersInit = true;

  function formatMoney(paise) {
    var amount = paise / 100;
    var rounded = Math.round(amount * 100) / 100;
    var str = rounded % 1 === 0 ? String(rounded) : rounded.toFixed(2);
    var parts = str.split('.');
    var intPart = parts[0];
    // Indian grouping: last three digits, then pairs.
    var lastThree = intPart.slice(-3);
    var rest = intPart.slice(0, -3);
    if (rest) lastThree = ',' + lastThree;
    var grouped = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;
    return 'Rs. ' + grouped + (parts[1] ? '.' + parts[1] : '');
  }

  // execCommand fallback: the async clipboard API needs a secure context
  // and can be blocked, and this still has to work on older mobile browsers.
  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.top = '-1000px';
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy') ? resolve() : reject();
      } catch (err) {
        reject(err);
      }
      document.body.removeChild(ta);
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    // Scoped to our own block: the theme's offers drawer uses data-copy-code
    // for its own copy buttons and must not be touched by this handler.
    var btn = e.target.closest('[data-pack-offers] [data-pack-copy-code]');
    if (!btn) return;
    e.preventDefault();

    var code = btn.dataset.packCopyCode;
    var label = btn.querySelector('.pack-offers__code-text');
    if (!label) return;

    copyText(code)
      .then(function () {
        if (btn.dataset.resetting === '1') return;
        btn.dataset.resetting = '1';
        btn.classList.add('is-copied');
        label.textContent = 'Copied!';
        setTimeout(function () {
          label.textContent = code;
          btn.classList.remove('is-copied');
          btn.dataset.resetting = '0';
        }, 1600);
      })
      .catch(function () {
        // Copy blocked: select the text so the customer can copy it manually.
        var range = document.createRange();
        range.selectNodeContents(label);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      });
  });

  window.addEventListener('variant:changed', function (e) {
    var root = document.querySelector('[data-pack-offers]');
    var variant = e.detail && e.detail.variant;
    if (!root || !variant) return;

    var unitPrice = variant.price;
    root.dataset.unitPrice = unitPrice;

    root.querySelectorAll('[data-pack-tile]').forEach(function (tile) {
      var qty = parseInt(tile.dataset.packQty, 10) || 1;
      var discount = parseInt(tile.dataset.packDiscount, 10) || 0;
      var net = Math.max(unitPrice * qty - discount * 100, 0);

      var nowEl = tile.querySelector('[data-pack-now]');
      var unitEl = tile.querySelector('[data-pack-unit]');

      if (nowEl) nowEl.textContent = formatMoney(net);
      if (unitEl) unitEl.textContent = formatMoney(Math.round(net / qty)) + '/item';
    });
  });
})();
